export default {
    close: 'Luk',
    dataIterator: {
      pageText: '{0}-{1} af {2}',
      noResultsText: 'Ingen matchende resultater',
      loadingText: 'Indlæser...',
    },
    dataTable: {
      itemsPerPageText: 'Rækker per side:',
      ariaLabel: {
        sortDescending: ': Sorted descending. Activate to remove sorting.',
        sortAscending: ': Sorted ascending. Activate to sort descending.',
        sortNone: ': Not sorted. Activate to sort ascending.',
      },
      sortBy: 'Sort by',
    },
    dataFooter: {
      pageText: '{0}-{1} af {2}',
      itemsPerPageText: 'Elementer per side:',
      itemsPerPageAll: 'Alle',
      nextPage: 'Næste side',
      prevPage: 'Forrige side',
      firstPage: 'Første side',
      lastPage: 'Sidste side',
    },
    datePicker: {
      itemsSelected: '{0} valgte',
    },
    noDataText: 'Ingen data tilgængelig',
    carousel: {
      prev: 'Previous visual',
      next: 'Next visual',
    },
    calendar: {
      moreEvents: '{0} mere',
    },
  }
